import { template } from "@ember/template-compiler";
import { action } from '@ember/object';
import { modifier } from 'ember-modifier';
import AttachTooltip from 'ember-attacher/components/attach-tooltip';
import Component from '@glimmer/component';
import SpdsRadioButton from 'ember-simplepractice/components/spds/input/radio-button';
export default class RequestClinicianSearchFiltersFilterRadioLine extends Component {
    get optionId() {
        return String(this.args.optionId ?? this.args.value ?? '').trim();
    }
    get radioId() {
        let kind1 = String(this.args.kind ?? 'service').trim();
        return `clinician-search-filter-${kind1}-${this.optionId}`;
    }
    get disabledHintId() {
        let kind1 = String(this.args.kind ?? 'service').trim();
        if (!this.optionId || !this.args.disabled || !this.args.title) {
            return null;
        }
        return `clinician-search-filter-${kind1}-${this.optionId}-disabled-hint`;
    }
    setupInputAttrs = modifier((element1)=>{
        let input1 = element1.querySelector('input');
        if (!input1) {
            return;
        }
        if (this.args.bucketIdsCsv?.length) {
            input1.setAttribute('data-test-clinician-search-filter-cpt-rate-bucket-ids', String(this.args.bucketIdsCsv));
        } else {
            input1.removeAttribute('data-test-clinician-search-filter-cpt-rate-bucket-ids');
        }
        if (this.disabledHintId) {
            input1.setAttribute('aria-describedby', this.disabledHintId);
        } else {
            input1.removeAttribute('aria-describedby');
        }
    });
    @action
    handleClick({ event: event1 }) {
        this.args.onChange?.(event1);
    }
    static{
        template(`
    <li
      class="filter-control-line"
      data-test-clinician-search-filter-option-doc-count={{@docCount}}
    >
      <SpdsRadioButton
        class="filter-radio-row"
        @id={{this.radioId}}
        @name={{@name}}
        @groupName={{@name}}
        @value={{@value}}
        @checked={{@checked}}
        @disabled={{@disabled}}
        @onClick={{this.handleClick}}
        {{this.setupInputAttrs}}
      >
        <:label>
          <span class="filter-checkbox-text">
            <span class="filter-option-text-content">{{yield}}</span>
            {{#if this.disabledHintId}}
              <span id={{this.disabledHintId}} class="visually-hidden">{{@title}}</span>
            {{/if}}
            {{#if @title}}
              <AttachTooltip
                @placement="right"
                @class="tooltip align-left filter-disabled-tooltip-popover"
              >
                {{@title}}
              </AttachTooltip>
            {{/if}}
          </span>
        </:label>
      </SpdsRadioButton>
    </li>
  `, {
            component: this,
            eval () {
                return eval(arguments[0]);
            }
        });
    }
}
